import axiosInstance from "./service-instance";
import { Map } from "immutable";

const getReportOptions = url => axiosInstance.get(`/${url}`);

const getReport = (reportId, filters) =>
    axiosInstance.get(`/report/${reportId}/data/`, {
        params: {
            ...new Map(filters)
                .map(_ =>
                    _.length && typeof _ === "object" ? JSON.stringify(_) : _
                )
                .toJS()
        }
    });

const getReportDetail = reportId => axiosInstance.get(`/report/${reportId}/`);

const getReportList = params =>
    axiosInstance.get("/report/group-list/", {
        params
    });

const getReportCategories = reportId =>
    axiosInstance.get("/report/list/", {
        params: {
            report_group: reportId
        }
    });

const downloadReport = (report_id, params={}) =>
    axiosInstance.get(`/report/${report_id}/download/`,
        {
            // headers: {
            //     accept: "multipart/form-data",
            // }
            params: {
                ...params
            },
            responseType: "arraybuffer"
        }
    );

export default {
    getReport,
    getReportDetail,
    getReportList,
    getReportCategories,
    getReportOptions,
    downloadReport
};
